import { StringField } from "../plugins/Cruxtify/field-types/StringField";

export class ComputedPriceField extends StringField {
  public static fieldName = "ComputedPriceField";

  protected _label: string = "Computed Price";
  protected _description: string =
    'Enter the formula for computing price. Use step shortnames and arithmetic operators only, e.g. "(variant1 * 1.5) + 3.14"';
}
